module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8etHZ"))).then(() => module.bundle.root('d0iPb'));